import { faMegaphone } from '@fortawesome/pro-solid-svg-icons';
import { getFeedback } from '@sentry/react';
import { DropdownMenuItem, Icon } from '@uturn/ui-kit';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const ReportABug = () => {
	// biome-ignore lint/suspicious/noExplicitAny: Lazy typing?
	const [form, setForm] = useState<any>();
	const { t } = useTranslation();
	const feedback = getFeedback();

	useEffect(() => {
		if (!feedback) {
			return;
		}

		(async () => {
			const feedbackDialog = await feedback?.createForm();
			setForm(feedbackDialog);
		})();
	}, [feedback]);

	const disabled = !feedback || !form;

	return (
		<DropdownMenuItem
			className="flex cursor-pointer gap-2"
			disabled={disabled}
			onClick={async () => {
				if (disabled) {
					return;
				}
				form.appendToDom();
				form.open();
			}}
		>
			<Icon icon={faMegaphone} />
			{t('header.navigation.user.report-a-bug', 'Report a bug')}
		</DropdownMenuItem>
	);
};

export default ReportABug;
